import { queryOptions } from "ui-common/query-options";
import { rpc } from "ui-common/services/rpc";

export const getCreators = (limit = 20, offset = 0, personalize = false, search?: string, categoryIds?: string[]) =>
  queryOptions({
    queryFn: () => rpc("get-creators", { limit, offset, personalize, search, categoryIds }),
    queryKey: ["getCreators", limit, offset, personalize, search, categoryIds] as const,
  });
